import React from "react";
import { connect } from "react-redux";
import {formValueSelector, reduxForm} from "redux-form";
import {ff, form, utils} from "@mc/mc-legacy";
import * as textNoteActions from "../../actions/textNoteActions";
import TextNoteField from "../field/TextNoteField";
const Form = form.Form;
const FormBody = form.FormBody;
const FormActions = form.FormActions;

const validate = (formData) => {
  const errors = {};

  if (formData.reason && formData.reason.length > 512) {
    errors.reason = "Důvod schválení může mít maximálně 512 znaků";
  }

  return errors;
};
/**
 * Formulář odmítnutí dokumentu.
 */

class SchvaleniForm extends React.Component {
  static formName = "SchvaleniForm";

    handleTextNoteChange = (data) => {
        const {change, reason} = this.props;
        if (data) {
            if (reason !== undefined) {
                change("reason", reason + data.note);
            } else {
                change("reason", data.note);
            }
        }
    }

  render() {
    const { onClose, handleSubmit, submitting, textNoteList, create } = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <FormBody>
          <ff.Textarea label="Poznámka ke schválení" name="reason" disabled={submitting} />
            {textNoteList && <ff.Base
                componentClass={TextNoteField}
                onTextNoteChange={this.handleTextNoteChange}
                name={"textNote"}
                label={"Vložit text"}
            />}
        </FormBody>
        <FormActions onClose={onClose} disabled={submitting} submitButton="Schválit" cancelButton />
      </Form>
    );
  }
}

function mapStateToProps(state) {
    const selector = formValueSelector(SchvaleniForm.formName);
    return {
        textNoteList: utils.storeFromArea(state, textNoteActions.TEXT_NOTE_LIST),
        reason: selector(state, "reason"),
    };
}

const reduxFormObj = reduxForm({
  form: SchvaleniForm.formName,
  validate: validate,
})(SchvaleniForm);
export default connect(mapStateToProps)(reduxFormObj);
